import React from 'react';
import Grid from "@mui/material/Grid";
import Typography from '@mui/material/Typography';

const useStyles = {
    text: {
        color: 'text.primary',
        fontSize: '1rem'
    },
    bold: {
        fontWeight: "bold",
    }
}

const Refund = () => {

    const classes = useStyles;

    return (
        <Grid container spacing={1} sx={classes.text}>
            <Grid style={{textAlign: 'center'}} size={12}>
                <Typography variant='h6' sx={classes.bold}>
                    {'Refund/Credit Policy'}
                </Typography>
            </Grid>
            <Grid size={12}>
                NEUMO Payments processes payments for agencies throughout the United States. If you use
                NEUMO Payments to make a payment to a government agency, the payment goes to that agency. Requests
                for refunds or credits must be authorized by the agency that was paid. Please contact
                the agency directly to submit your request. The Payment Service Fee associated with
                your payment is Non-Refundable.
            </Grid>
        </Grid>
    );
}

export default Refund;
